'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

var _detachEvent = require('./detachEvent');

var _detachEvent2 = _interopRequireDefault(_detachEvent);

var _attachEvent = require('./attachEvent');

var _attachEvent2 = _interopRequireDefault(_attachEvent);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

// TODO(jdm): this would be much more efficient server-side
exports.default = function (feis_id, from_stage_id, to_stage_id, item, before_id, after_id) {
  return function (dispatch) {
    return dispatch((0, _detachEvent2.default)(feis_id, from_stage_id, item)).then(function () {
      return dispatch((0, _attachEvent2.default)(feis_id, to_stage_id, item, before_id, after_id));
    });
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/stages/moveEvent.js
// module id = 683
// module chunks = 0